var CollectionView = require('views/base/collection-view');
var View = require('views/base/view');

var ActivityCollectionView = CollectionView.extend({
  autoRender: true,
  template: require('./templates/activity-collection'),
  itemView: require('./activity-item-view'),
  listSelector: '.activity-items',
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      autoRender: false,
      model: model,
      activityTemplate: this.model.get('activity_template'),
      showPages: this.model.get('show_pages'),
      disableIfLocked: this.model.get('disable_if_locked'),
      activityLinkClass: this.model.get('activity_link_class')
    });
  },
  getTemplateData: View.prototype.getTemplateData
});

module.exports = ActivityCollectionView;
